import VueSanitize from "vue-3-sanitize";

const Sanitize = VueSanitize;
const SanitizeDefaults = VueSanitize.defaults;

export { Sanitize, SanitizeDefaults };
